import styles from "./FormTitle.module.scss";

type FormTitleProps = { title: string };

const FormTitle = ({ title }: FormTitleProps) => {
  return <h1 className={styles.title}>{title}</h1>;
};
export default FormTitle;
